<template>
    <tabbar :tabbar="navData"></tabbar>
</template>

<script>
    import tabbar from '@/components/Tabbar'

    export default {
        components: {
            tabbar
        },
        data() {
            return {
                navData: [
                    {
                        name: '首页',
                        path: this.getCurrentPathWithTraderId('/aq/index'),
                        pathName: 'aqIndex',
                        icon: 'home',
                        dot: false,
                        info: '',
                    },
                    {
                        name: '订单',
                        path: this.getCurrentPathWithTraderId('/aq/orderList'),
                        pathName: 'aqOrderList',
                        icon: 'zhangdan',
                        dot: false,
                        info: ''
                    }
                ]
            }
        },
        watch: {
            // 监听路由变化，更新激活状态
            '$route'() {
                this.updateActiveTab()
            }
        },
        mounted() {
            this.updateActiveTab()
        },
        methods: {
            updateActiveTab() {
                const currentPath = this.$route.path;

                this.navData.forEach((item, index) => {
                    if (currentPath === item.path.split('?')[0]) {
                        this.$set(item, 'isActive', true)
                    } else {
                        this.$set(item, 'isActive', false)
                    }
                })
            },
            getCurrentPathWithTraderId(defaultPath) {
                const traderId = this.$route.query.traderId || this.$route.params.traderId || this.$route.query.tradeId || this.$route.params.tradeId
                if (traderId) {
                    return `${defaultPath}?traderId=${traderId}`
                }
                return defaultPath
            }
        }
    }
</script>
